import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "vf-trace-transaction-id": crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const deleteTFStateLocks = async (serviceName, dryRun = false) => {
  const response = await axios.delete(
    `${PROCESS_AUTOMATION_SERVICE_URL}/utils/dynamodb-locks?serviceName=${encodeURIComponent(serviceName)}&dryRun=${dryRun}`,
    {
      headers: {
        ...getHeaders(),
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};
